import { useCallback } from 'react';

import { PageTitle, VerticalContainer } from '@american-autonomy/rantizo-ui';

import UserDetailsEditCard from 'components/cards/UserDetailsEditCard';

import useNavigation from 'hooks/useNavigation';
import usePageRoutes from 'hooks/usePageRoutes';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const AccountDetails: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { navigate } = useNavigation();
    const { editUserDetailsPage } = usePageRoutes();
    const { TITLE } = useTranslation();

    const { email, firstName, lastName, phoneNumber } = useData();

    const handleEdit = useCallback(() => {
        navigate(editUserDetailsPage);
    }, [editUserDetailsPage, navigate]);

    return (
        <VerticalContainer testId={testId}>
            <PageTitle className={styles.pageTitle} text={TITLE} />

            <UserDetailsEditCard
                editable={true}
                email={email}
                firstName={firstName}
                lastName={lastName}
                onEdit={handleEdit}
                phoneNumber={phoneNumber}
            />
        </VerticalContainer>
    );
};

export default AccountDetails;
